// Available Endorsements Response (POST applications/availableEndorsements) - EPLI has options object
// {
//   "availableEndorsements": {
//      "contractorsToolsEndorsement": "{\"contractorsToolsEndorsement\":true, \"selectedContractorsToolsLimit\":5000, \"toolsAndEquipmentCoverageType\":blanket}",
//   },
// }
//
// Application Update Payload (POST applications)
// {
//    contractorsInstallationAndTools: {
//      selectedContractorsToolsLimit: '10000'
//.    }
// }
import { useSelector, useDispatch } from 'react-redux';
import { setContractorToolsCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { selectContractorToolsLimit, selectCheckedEndorsements } from '../../../../selectors/application';
import { selectLoadingState } from '../../../../selectors';
import styled from 'styled-components';
import EndorsementCard from '../../EndorsementCard';
import UnderwritingRadioGroup from '../../shared/UnderwritingRadioGroup';
import CenteredLoadingSpinner from '../../../AddOns/shared/CenteredLoadingSpinner';
import { config, DEFAULT_LIMITS_OPTIONS } from './ContractorTools.config';

const { endorsementKey: ENDORSEMENT_KEY, label: LABEL, description: DESCRIPTION } = config;

const ContractorTools = () => {
  const dispatch = useDispatch();
  const isQuoteLoading = useSelector(selectLoadingState);
  const contractorToolsLimitValue = useSelector(selectContractorToolsLimit);
  const isSelected = useSelector(selectCheckedEndorsements).includes(ENDORSEMENT_KEY);

  const handleCheckboxChange = (checked: boolean) => {
    dispatch(setCheckedEndorsement(ENDORSEMENT_KEY, checked));
    const limit = checked ? String(DEFAULT_LIMITS_OPTIONS[0].value) : null;
    // will call quote/bindable endpoint with updated endorsement limit through redux middleware
    dispatch(
      setContractorToolsCoverage({
        selectedContractorsToolsLimit: limit,
      })
    );
  };

  const handleLimitsChange = (newValue: string) => {
    // will call quote/bindable endpoint with updated endorsement limit through redux middleware
    dispatch(setContractorToolsCoverage({ selectedContractorsToolsLimit: newValue }));
  };

  return (
    <EndorsementCard
      endorsementKey={ENDORSEMENT_KEY}
      label={LABEL}
      description={DESCRIPTION}
      isSelected={isSelected}
      onCheckboxChange={handleCheckboxChange}
      hasExpandableContent
    >
      <SubQuestionsContainer>
        {isQuoteLoading && <CenteredLoadingSpinner useAltColor />}
        <UnderwritingRadioGroup
          questionCopy="Choose your total coverage amount:"
          options={DEFAULT_LIMITS_OPTIONS}
          selectedValue={contractorToolsLimitValue}
          onChange={handleLimitsChange}
          name="contractor-tools-limits"
          isActive={!isQuoteLoading}
        />
      </SubQuestionsContainer>
    </EndorsementCard>
  );
};

const SubQuestionsContainer = styled.div`
  position: relative;
`;

export default ContractorTools;
